// import { $translate } from '@/utils/i18n';
export const nodeConfig = {
    configuration: true,
    searchList: {
        searchLeftSpan: 18,
        searchRightSpan: 12,
        searchTxt: [
            {
                type: 'input',
                span: 12,
                value: 'nodeCode',
                name: '节点编码',
                clearable: true
            }, {
                type: 'input',
                span: 12,
                value: 'nodeName',
                name: '节点名称',
                clearable: true
            }
        ],
        unfoldState: false,
        advancedBtn: true
    },
    table: {
        sequence: false,
        selectBtn: true,
        clickState: true,
        leftOperation: false,
        height: 400,
        rowKey: 'nodeCode',
        columns: [
            {
                label: '节点编码',
                align: 'center',
                prop: 'nodeCode',
                filter: true,
                require: true,
                sort: false,
                width: 90
            },
            {
                label: '节点名称',
                align: 'left',
                prop: 'nodeName',
                filter: true,
                require: true,
                sort: false,
                width: 200
            }, {
                label: '备注',
                align: 'center',
                prop: 'remark',
                filter: true,
                require: true,
                sort: false,
                width: 120
            }
        ]
    },
    page: {
        layout: 'total, sizes, prev, pager, next, jumper',
        pageSize: 10,
        pageNo: 1,
        pageSizes: [10, 20, 30, 50, 100]
    },
    showPage: true
};
